// extracted by mini-css-extract-plugin
module.exports = {"notificationWidget":"NotificationWidget_notificationWidget__1HxTV"};